<template lang="pug">
	.fondoModal
		div
			div
				div.card
					div.card-header {{datos.campo.nombre}} ({{datos.agente.info.nombre}}) - {{datos.dimension}}
						button.close(@click="cerrar") &times;
					div.mt-2
						ul.nav.nav-tabs
							li.nav-item(style="cursor:pointer")
								a(:class="(seccion === 'real') ? 'active' : ''" class="nav-link" @click="setSeccion('real')") Real
							li.nav-item(style="cursor:pointer")
								a(:class="(seccion === 'acumulado') ? 'active' : ''" class="nav-link" @click="setSeccion('acumulado')") Acumulado
							li.nav-item(style="cursor:pointer")
								a(:class="(seccion === 'total') ? 'active' : ''" class="nav-link" @click="setSeccion('total')") Total
							li.nav-item(style="cursor:pointer")
								a(:class="(seccion === 'contratos') ? 'active' : ''" class="nav-link" @click="setSeccion('contratos')") Contratos
					div
						div(v-if="seccion === 'real'")
							h4 Real
							representar(v-if="datosReal" :datos="datosReal")
						div(v-if="seccion === 'acumulado'")
							h4 Real acumulado
							representar(v-if="datosRealAcumulado" :datos="datosRealAcumulado")
						div(v-if="seccion === 'total'")
							h4 Total anual
							representar(v-if="datosRealTotal" :datos="datosRealTotal")
						div.table-responsive.text-left(v-if="seccion === 'contratos'")
							download-excel.m-2(
								class   = "btn btn-warning btn-sm"
								:data   = "json_data"
								:fields = "json_fields"
								:meta   = "json_meta"
								name	= "informe.xls"
							)
								span.fa.fa-download.mr-2
								| XLS
							table.table.table-striped.table-condensed
								thead
									tr
										th Mes
										th Soporte
										th Cliente
										th Agente
										th Contrato
										th.text-right Importe
								tbody
									tr(v-for="linea in lineasFacturacion" :key="linea.ID_contrato")
										td {{meses[linea.fecha.getMonth()]}}, {{linea.fecha.getFullYear()}}
										td {{linea.soporteNombre}}
										td {{linea.clienteNombre}}
										td {{linea.agenteNombre}}
										td.contrato(@click="ContratoID = linea.contratoId") {{linea.contratoTitulo}}
										td.text-right {{linea.importe | currency('')}} €
								tbody
									tr.bg-dark.text-white
										td(colspan="5" class="text-right")
											b Total
										td.text-right {{sumaFacturacion | currency('')}} €

		modal(:max-width="1600", v-if='ContratoID', :top="10")
			.card.text-left
				.card-header
					button.close(@click="ContratoID=null") &times;
				.card-body
					VisorContrato(:ContratoID="ContratoID")
	</div>
</template>

<script>
import Representacion from './representarDatos'
import VisorContrato from '../../../../mis-contratos/vue/components/visor-contrato/visor-contrato.vue'
export default {
	props: ['datos'],
	components: {
		'representar': Representacion,
		VisorContrato: VisorContrato
	},

	data: function () {
		return {
			meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			seccion: 'real',
			ContratoID: null
		}
	},

	created () {},

	computed: {
		json_data () {
			if (!this.lineasFacturacion) {
				return []
			}

			return this.lineasFacturacion.reduce((acum, contrato) => {
				const item = {
					mes: this.meses[contrato.fecha.getMonth()] + ', ' + contrato.fecha.getFullYear(),
					soporte: contrato.soporteNombre,
					cliente: contrato.clienteNombre,
					agente: contrato.agenteNombre,
					contrato: contrato.contratoTitulo,
					importe: this.$options.filters.currency(contrato.importe)
				}
				acum.push(item)
				return acum
			}, [])
		},
		json_fields () {
			if (!this.lineasFacturacion) {
				return {}
			}
			const f = {}

			f.mes = 'String'
			f.soporte = 'String'
			f.cliente = 'String'
			f.agente = 'String'
			f.contrato = 'String'
			f.importe = 'String'
			return f
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		},
		/**
		 * Devuelve un array con la factuación procesada (rellenando con ceros los meses intermedios)
		 */
		facturacion () {
			const arr = []
			if (!this.datos) {
				return {}
			}

			const f = this.datos.facturacion

			for (let i = 0; i < f.length; i++) {
				const fecha = new Date(parseInt(f[i].fecha) * 1000)
				const clave = new Date(fecha.getFullYear(), fecha.getMonth(), 1, 0, 0, 0, 0)

				let encontrado = false
				for (let a = 0; a < arr.length; a++) {
					if (arr[a].fecha.getTime() === clave.getTime()) {
						arr[a].importe = arr[a].importe + parseFloat(f[i].importe)
						encontrado = true
					}
				}

				if (!encontrado) {
					arr.push({
						fecha: clave,
						importe: parseFloat(f[i].importe),
						clienteNombre: f[i].clienteNombre,
						agenteNombre: f[i].agenteNombre,
						contratoTitulo: f[i].contratoTitulo
					})
				}
			}

			if (this.datos.fechas.fecha_fin !== this.datos.fechas.fecha_ini) {
				// Rellenamos
				let actual = this.datos.fechas.fecha_ini

				do {
					let encontrado = false

					for (let a = 0; a < arr.length; a++) {
						if (arr[a].fecha.getTime() === actual.getTime()) {
							encontrado = true
						}
					}

					if (!encontrado) {
						arr.push({
							fecha: actual,
							importe: 0
						})
					}

					const mes = actual.getMonth()
					let ano = actual.getFullYear()
					let nuevoMes = null
					if (mes < 11) {
						nuevoMes = mes + 1
					} else {
						nuevoMes = 0
						ano = ano + 1
					}

					actual = new Date(ano, nuevoMes, 1, 0, 0, 0, 0)
				} while (actual.getTime() < this.datos.fechas.fecha_fin.getTime())
			}

			// ordenamos por clave
			arr.sort((a, b) => {
				if (a.fecha > b.fecha) {
					return 1
				} else {
					return -1
				}
			})

			return arr
		},

		lineasFacturacion () {
			const arr = []

			for (let i = 0; i < this.datos.facturacion.length; i++) {
				const f = this.datos.facturacion[i]
				const fecha = new Date(parseInt(f.fecha) * 1000)

				const nuevo = _.clone(f)
				nuevo.fecha = fecha
				arr.push(nuevo)
			}
			return arr
		},

		sumaFacturacion () {
			let importe = 0
			for (let i = 0; i < this.datos.facturacion.length; i++) {
				importe += parseFloat(this.datos.facturacion[i].importe)
			}

			return importe
		},

		labelsDatasetReal () {
			const arr = []
			for (let i = 0; i < this.facturacion.length; i++) {
				const label = this.meses[this.facturacion[i].fecha.getMonth()]
				if (arr.indexOf(label) < 0) {
					arr.push(label)
				}
			}
			return arr
		},
		datasetReal () {
			const ds = []

			for (let i = 0; i < this.facturacion.length; i++) {
				const fecha = this.facturacion[i].fecha
				const ano = fecha.getFullYear().toString()
				const mes = fecha.getMonth()
				const importe = parseFloat(this.facturacion[i].importe)

				let encontrado = false
				for (let a = 0; a < ds.length; a++) {
					if (ds[a].label === ano) {
						encontrado = true
						ds[a].data[mes] = (typeof ds[a].data[mes] !== 'undefined') ? ds[a].data[mes] + importe : importe
					}
				}

				if (!encontrado) {
					const color = this.getRandomColor()
					const nuevo = {
						label: ano,
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					}
					nuevo.data[mes] = importe
					ds.push(nuevo)
				}
			}

			return ds
		},

		datosReal () {
			return {
				labels: this.labelsDatasetReal,
				datasets: this.datasetReal,
				tipo: 'barras'
			}
		},

		/**
		 * TOTAL ANUAL
		 */
		graficoAnual () {
			const datos = {}

			for (let i = 0; i < this.facturacion.length; i++) {
				const ano = this.facturacion[i].fecha.getFullYear().toString()
				const importe = parseFloat(this.facturacion[i].importe)

				if (!datos[ano]) {
					datos[ano] = importe
				} else {
					datos[ano] = datos[ano] + importe
				}
			}

			return datos
		},

		datosRealTotal () {
			return {
				tipo: 'barras',
				labels: Object.keys(this.graficoAnual),
				datasets: [
					{
						label: 'Total anual',
						data: Object.values(this.graficoAnual)
					}
				]
			}
		},

		/**
		 * REAL ACUMULADO
		 */

		datasetRealAcum () {
			const ds = []

			for (let i = 0; i < this.facturacion.length; i++) {
				const fecha = this.facturacion[i].fecha
				const ano = fecha.getFullYear().toString()
				const mes = fecha.getMonth()
				const importe = parseFloat(this.facturacion[i].importe)

				let encontrado = false
				for (let a = 0; a < ds.length; a++) {
					if (ds[a].label === ano) {
						encontrado = a
					}
				}

				if (encontrado === false) {
					const color = this.getRandomColor()
					const nuevo = {
						label: ano,
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					}
					ds.push(nuevo)
					encontrado = ds.length - 1
				}

				let m = mes
				while (m <= 11) {
					ds[encontrado].data[m] = (typeof ds[encontrado].data[m] === 'undefined') ? importe : ds[encontrado].data[m] + importe
					m++
				}
			}

			return ds
		},

		datosRealAcumulado () {
			return {
				tipo: 'lineas',
				labels: this.labelsDatasetReal,
				datasets: this.datasetRealAcum
			}
		}
	},

	methods: {
		setSeccion (seccion) {
			this.seccion = seccion
		},
		getRandomColor () {
			var letters = '0123456789ABCDEF'
			var color = '#'
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)]
			}
			return color
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>
<style scoped>
.contrato {
	cursor: pointer;
}
.contrato:hover {
	color: darkblue;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modulos/consultas-facturacion/vue/components/porAgente/graficoDetalle.vue